/** Resolves customGroupIds to a comma-separated display string of group names. */
const resolveFunctionNames = (customGroupIds: string[] | undefined, groupNameById: Map<string, string>): string =>
  (customGroupIds || [])
    .map((id) => groupNameById.get(id))
    .filter(Boolean)
    .join(', ');

export default resolveFunctionNames;
